module.exports = __webpack_public_path__ + "img/parent-feed-bg.2147cc27.jpg";